export default __webpack_public_path__ + "static/media/tab1.576b697d.svg";